/**
 * TanStack Query hooks for `fraud-tool-access-permission-per-role`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	fraudToolAccessPermissionPerRoleQueryKeys,
	type CreateFraudToolAccessPermissionPerRoleBody,
	type ListFraudToolAccessPermissionPerRoleResponse,
	type FraudToolAccessPermissionPerRoleRow,
} from "./api";

export function useFraudToolAccessPermissionPerRoleList(): UseQueryResult<ListFraudToolAccessPermissionPerRoleResponse, Error> {
	return useQuery({
		queryKey: fraudToolAccessPermissionPerRoleQueryKeys.list(),
		queryFn: list,
	});
}

export function useFraudToolAccessPermissionPerRoleCreate(): UseMutationResult<FraudToolAccessPermissionPerRoleRow, Error, CreateFraudToolAccessPermissionPerRoleBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fraudToolAccessPermissionPerRoleQueryKeys.all });
		},
	});
}

export function useFraudToolAccessPermissionPerRoleDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fraudToolAccessPermissionPerRoleQueryKeys.all });
		},
	});
}
